import type { CharacterSpec } from './rig.js';

/** Original CrowdSet characters. Head centre (40,31) r17; torso y52–86. */
export const CHARACTERS: Record<string, CharacterSpec> = {
  nova: {
    skin: '#f1c7a5',
    top: '#5d6b4b',
    legs: '#2b2f3a',
    shoes: '#e9e6df',
    back: (
      <path
        d="M21 30 Q21 11 40 11 Q59 11 59 30 L59 44 Q52 48 48 44 L32 44 Q28 48 21 44 Z"
        fill="#c9d1da"
      />
    ),
    torso: (
      <>
        <path d="M33 52 L40 60 L47 52" fill="#e0874a" />
        <rect x="27" y="82" width="26" height="4" rx="2" fill="#4c5a3d" />
      </>
    ),
    hair: <path d="M22 28 Q22 12 40 12 Q58 12 58 28 Q50 20 40 21 Q29 21 22 28 Z" fill="#dde3ea" />,
    face: <rect x="27" y="29" width="26" height="8" rx="4" fill="#7fc9d8" opacity=".85" />,
  },
  juno: {
    skin: '#8d5a3b',
    top: '#f4efe6',
    sleeve: '#f4efe6',
    legs: '#3f6ea8',
    shoes: '#d9533f',
    torso: (
      <>
        <path d="M29 62 L51 62 L53 86 Q40 90 27 86 Z" fill="#3f6ea8" />
        <rect x="31" y="53" width="3" height="10" fill="#3f6ea8" />
        <rect x="46" y="53" width="3" height="10" fill="#3f6ea8" />
        <circle cx="32.5" cy="63" r="1.4" fill="#e7c65b" />
        <circle cx="47.5" cy="63" r="1.4" fill="#e7c65b" />
      </>
    ),
    hair: (
      <g fill="#2a1a12">
        <circle cx="40" cy="10" r="9" />
        <circle cx="31" cy="13" r="7" />
        <circle cx="49" cy="13" r="7" />
        <circle cx="25" cy="21" r="5.5" />
        <circle cx="55" cy="21" r="5.5" />
        <circle cx="40" cy="17" r="8" />
      </g>
    ),
    headTop: (
      <>
        <path d="M22 30 Q22 9 40 9 Q58 9 58 30" stroke="#2e2f36" strokeWidth="3" fill="none" />
        <rect x="17" y="26" width="8" height="13" rx="3.5" fill="#f2b33d" />
        <rect x="55" y="26" width="8" height="13" rx="3.5" fill="#f2b33d" />
      </>
    ),
  },
  bramble: {
    skin: '#f5d0b5',
    top: '#7a8f5a',
    legs: '#3d3a36',
    shoes: '#6b4a32',
    torso: (
      <g stroke="#687c4b" strokeWidth="1.4">
        <line x1="33" y1="58" x2="33" y2="84" />
        <line x1="40" y1="58" x2="40" y2="86" />
        <line x1="47" y1="58" x2="47" y2="84" />
        <rect x="28" y="52" width="24" height="5" rx="2.5" fill="#8ea46c" stroke="none" />
      </g>
    ),
    hair: (
      <>
        <path d="M24 16 L27 3 L35 13 Z" fill="#d9713a" />
        <path d="M56 16 L53 3 L45 13 Z" fill="#d9713a" />
        <path d="M26.5 8 L27.5 4 L30 8.5 Z" fill="#fbeee2" />
        <path d="M53.5 8 L52.5 4 L50 8.5 Z" fill="#fbeee2" />
        <path d="M22 27 Q22 11 40 11 Q58 11 58 27 Z" fill="#d9713a" />
        <rect x="21" y="23" width="38" height="6" rx="3" fill="#b95b2c" />
      </>
    ),
  },
  koji: {
    skin: '#e9c49a',
    top: '#8c2f39',
    sleeve: '#efe6d2',
    legs: '#2f3340',
    shoes: '#f1f1ee',
    torso: (
      <>
        <rect x="41" y="60" width="8" height="9" rx="1.5" fill="#efe6d2" />
        <path d="M43 67 L45 62 L47 67" stroke="#8c2f39" strokeWidth="1.4" fill="none" />
        <rect x="27" y="82" width="26" height="4" rx="2" fill="#efe6d2" />
      </>
    ),
    hair: (
      <path
        d="M22 27 L20 17 L27 20 L27 9 L34 15 L37 4 L42 13 L48 5 L49 15 L56 10 L55 20 L61 19 L58 27 Q50 19 40 19 Q30 19 22 27 Z"
        fill="#1b1b22"
      />
    ),
    face: (
      <g stroke="#2a2a30" strokeWidth="1.5" fill="none">
        <circle cx="33.5" cy="33" r="4.6" />
        <circle cx="46.5" cy="33" r="4.6" />
        <line x1="38.1" y1="33" x2="41.9" y2="33" />
      </g>
    ),
  },
  marlo: {
    skin: '#6b4128',
    top: '#2f7f7a',
    legs: '#2a2d35',
    shoes: '#f4f1ea',
    torso: (
      <>
        <rect x="21" y="58" width="2" height="20" fill="#f4f1ea" />
        <rect x="57" y="58" width="2" height="20" fill="#f4f1ea" />
        <line x1="40" y1="53" x2="40" y2="87" stroke="#f4f1ea" strokeWidth="1.2" />
      </>
    ),
    hair: (
      <g fill="#221610">
        <path d="M23 27 Q23 13 40 13 Q57 13 57 27 Q50 20 40 20 Q30 20 23 27 Z" />
        <ellipse cx="40" cy="7" rx="8" ry="6" />
        <path
          d="M34 9 Q30 1 26 -1 M46 9 Q50 1 54 -1 M40 5 Q40 -2 38 -4"
          stroke="#221610"
          strokeWidth="3"
          fill="none"
          strokeLinecap="round"
        />
      </g>
    ),
    headTop: (
      <g stroke="#e5b84a" strokeWidth="1.6" fill="none">
        <circle cx="23" cy="40" r="3.4" />
        <circle cx="57" cy="40" r="3.4" />
      </g>
    ),
  },
  vesper: {
    skin: '#c98e6b',
    top: '#463a4f',
    legs: '#1f1e24',
    shoes: '#1f1e24',
    back: (
      <g fill="#3a2230">
        <ellipse cx="54" cy="52" rx="4.5" ry="6" />
        <ellipse cx="55" cy="62" rx="4" ry="5.5" />
        <ellipse cx="55.5" cy="71" rx="3.5" ry="5" />
        <ellipse cx="56" cy="79" rx="3" ry="4.5" />
        <path d="M54 83 L56 90 L58 83 Z" />
      </g>
    ),
    torso: (
      <path d="M40 53 L40 86 M36 53 L40 62 L44 53" stroke="#35293d" strokeWidth="1.4" fill="none" />
    ),
    lowerOverride: (
      <g>
        <rect x="31" y="84" width="7.5" height="23" rx="3" fill="#1f1e24" />
        <rect x="41.5" y="84" width="7.5" height="23" rx="3" fill="#1f1e24" />
        <path d="M27 80 L53 80 L57 101 Q40 104 23 101 Z" fill="#463a4f" />
        <ellipse cx="34" cy="109.5" rx="5.5" ry="3.2" fill="#1f1e24" />
        <ellipse cx="46" cy="109.5" rx="5.5" ry="3.2" fill="#1f1e24" />
      </g>
    ),
    hair: <path d="M22 31 Q21 12 40 12 Q59 12 58 31 Q54 20 44 18 Q33 18 22 31 Z" fill="#3a2230" />,
    headTop: (
      <g fill="#f6d36b">
        <path d="M23 40 l1.2 2.6 2.8.3-2.1 1.9.6 2.8-2.5-1.4-2.5 1.4.6-2.8-2.1-1.9 2.8-.3z" />
        <path d="M57 40 l1.2 2.6 2.8.3-2.1 1.9.6 2.8-2.5-1.4-2.5 1.4.6-2.8-2.1-1.9 2.8-.3z" />
      </g>
    ),
  },
  tuck: {
    skin: '#f0bf9a',
    top: '#f3f1ec',
    legs: '#4d5568',
    shoes: '#f5f5f2',
    torso: (
      <g fill="#2c3e66">
        <rect x="27" y="60" width="26" height="3" />
        <rect x="27" y="68" width="26" height="3" />
        <rect x="27" y="76" width="26" height="3" />
      </g>
    ),
    lowerOverride: (
      <g>
        <rect x="30.5" y="84" width="8" height="21" rx="3.5" fill="#4d5568" />
        <rect x="41.5" y="84" width="8" height="21" rx="3.5" fill="#4d5568" />
        <rect x="26" y="103" width="15" height="8" rx="4" fill="#f5f5f2" />
        <rect x="39" y="103" width="15" height="8" rx="4" fill="#f5f5f2" />
        <rect x="26" y="108" width="15" height="3" rx="1.5" fill="#c9463d" />
        <rect x="39" y="108" width="15" height="3" rx="1.5" fill="#c9463d" />
      </g>
    ),
    hair: (
      <>
        <path d="M24 24 Q25 9 40 9 Q55 9 56 24 Z" fill="#d8c07a" />
        <path d="M16 26 Q40 16 64 26 Q40 31 16 26 Z" fill="#c6ad66" />
      </>
    ),
  },
  odette: {
    skin: '#fbe0cc',
    top: '#26262c',
    legs: '#6e5a4a',
    shoes: '#2a2320',
    torso: <rect x="31" y="49" width="18" height="7" rx="3.5" fill="#333339" />,
    hair: (
      <path
        d="M22 32 Q20 12 40 12 Q60 12 58 30 Q52 22 45 23 Q42 17 34 22 Q27 24 22 32 Z"
        fill="#8a3b24"
      />
    ),
    face: (
      <g stroke="#1e1e22" strokeWidth="1.6" fill="none" strokeLinejoin="round">
        <path d="M27.5 31 L38.5 31 L37.5 36 Q33 37.5 29 36 Z M26 29.5 L27.5 31" />
        <path d="M52.5 31 L41.5 31 L42.5 36 Q47 37.5 51 36 Z M54 29.5 L52.5 31" />
      </g>
    ),
  },
  rafi: {
    skin: '#a8704a',
    top: '#5c6470',
    legs: '#2e3138',
    shoes: '#d6d2c8',
    back: <path d="M28 52 Q40 44 52 52 L50 57 Q40 52 30 57 Z" fill="#4c535e" />,
    torso: (
      <>
        <line x1="40" y1="54" x2="40" y2="86" stroke="#9aa2ad" strokeWidth="1.3" />
        <rect x="31" y="72" width="18" height="7" rx="2" fill="#535a65" />
      </>
    ),
    face: <path d="M24 34 Q25 49 40 50 Q55 49 56 34 Q52 43 40 44 Q28 43 24 34 Z" fill="#2d1f17" />,
    hair: (
      <>
        <path d="M23 26 Q24 12 40 12 Q56 12 57 26 Z" fill="#c24a3a" />
        <path d="M50 21 Q60 19 64 25 Q58 26 54 26 Z" fill="#a33b2d" />
        <circle cx="40" cy="12.5" r="1.8" fill="#a33b2d" />
      </>
    ),
  },
  sable: {
    skin: '#b8c0c8',
    top: '#8d97a3',
    sleeve: '#7c8692',
    legs: '#6c7581',
    shoes: '#4b525c',
    hands: '#aab3bc',
    customHead: (
      <>
        <line x1="40" y1="13" x2="40" y2="5" stroke="#8d97a3" strokeWidth="2" />
        <circle className="cs-av-led" cx="40" cy="4.5" r="2.4" fill="#e8a33d" />
        <rect x="23" y="13" width="34" height="33" rx="11" fill="#b8c0c8" />
        <rect x="27" y="23" width="26" height="12" rx="6" fill="#1c2230" />
        <circle className="cs-av-led" cx="34" cy="29" r="2.4" fill="#63d7e8" />
        <circle className="cs-av-led" cx="46" cy="29" r="2.4" fill="#63d7e8" />
        <rect x="35" y="39" width="10" height="2" rx="1" fill="#6c7581" />
      </>
    ),
    torso: (
      <>
        <rect x="33" y="60" width="14" height="10" rx="2" fill="#6c7581" />
        <circle cx="37" cy="65" r="1.5" fill="#63d7e8" />
        <circle cx="43" cy="65" r="1.5" fill="#e8a33d" />
      </>
    ),
  },
};
